import React from 'react';
import {Header} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import * as RESOURCES from '@constants/resources';
import {Authorization} from '@appComponents/Authorization';
import * as CONST from '@constants/variables';
import {IconDelete, IconInfoCircleChangelog} from '@appComponents/IconCollection';
import {showModal, showModalConfirmation} from '@utils/modal';
import {refetchQueryByName} from '@utils/apollo';
import EventContentMultiAudioModal from '@modules/events/components/EventContentMultiAudioModal';

export const ButtonsForEditableRowInViewMode = ({data, encodingTargetId, deleteMutation, addMessage}) => {
    const handleMultiAudioDelete = (id, encodingTargetId) => {
        showModalConfirmation({
            header: <Header icon='trash' content='Delete audio'/>,
            text: 'Are you sure you want to remove this audio?',
            onYes: () => deleteMultiAudio(id, encodingTargetId),
            onNo: () => reRenderModal(encodingTargetId),
        });
    };

    const deleteMultiAudio = (id, encodingTargetId) => {
        showModalConfirmation({text: 'The audio is being deleted...'});

        deleteMutation({variables: {id: id}})
            .then(() => {
                addMessage('eventAudioMessage', null, 'The audio has been deleted successfully.', 'success');
                refetchQueryByName('GetEncodingTargetsForDistributions');
                refetchQueryByName('GetEventContentEncodingConfigurationChanged');
                reRenderModal(encodingTargetId);
            })
            .catch((error) => {
                addMessage('eventAudioMessage', 'The audio could not be deleted.', `${error}`, 'error');
            });
    };

    const reRenderModal = (encodingTargetId) => {
        showModal({
            isVisible: true,
            content: <EventContentMultiAudioModal encodingTargetId={encodingTargetId} key={encodingTargetId}/>,
            size: 'small',
        });
    };

    return (
        <div className='actions-list-icon'>
            <Authorization authorization={{[RESOURCES.AUDIO]: CONST.SECURITY_PRIVILEGES_DELETE}}>
                <IconDelete icon='trash' onClick={() =>
                    handleMultiAudioDelete(data.id, encodingTargetId)} onClickElement={data.id}/>
            </Authorization>
            <IconInfoCircleChangelog
                tooltipProps={{hoverable: true, position: 'top right'}}
                resources={RESOURCES.AUDIO}
                data={data}
            />
        </div>
    );
};

ButtonsForEditableRowInViewMode.propTypes = {
    data: PropTypes.object.isRequired,
    encodingTargetId: PropTypes.number.isRequired,
    deleteMutation: PropTypes.func.isRequired,
    addMessage: PropTypes.func.isRequired,
};
